import {
  appendBlueprintImages,
  getBlueprintImages,
  setInitialParams,
  setBlueprintImageParam,
  addCardToMyCollection,
  addCardToWishlist,
  viewOffers,
  setShowErrorModal,
  setShowSuccessModal,
  setBlueprintImage2ShowLargeImage,
  setShowZoomImg,
  setShowSuccessFlashMessage,
  getExpansions,
  getEras,
  getNewOptionsForFilters
} from "../../reducers/blueprint_images_reducer";
import I18n from 'i18n.js.erb'
import {reducer} from "../../reducers/blueprint_images_reducer";
import React, {useEffect, useRef, useState} from "react";
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {Provider, useDispatch, useSelector} from "react-redux";
import FilterBlueprintImages from "./FilterBlueprintImages";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import {
  displayTranslations,
  getArtwork,
  IPAD_WIDTH,
  onKeyDownQuantity,
  parseCategoryName,
  titleize,
  parseLanguage,
  compareStrings,
  SMALL_PER_PAGE_PARAM
} from "../../utils/utils";
import ErrorModal from "./ErrorModal";
import SuccessModal from "./SuccessModal";
import ShowLargeImageModal from "./ShowLargeImageModal";
import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup";
import SwitchDisplay from "./SwitchDisplay";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import IconTooltip from "./IconTooltip";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import AlertPopup from "./AlertPopup";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import GameNameParser from "./GameNameParser";
import ExpansionIcon from "./ExpansionIcon";
import BlueprintImageAccordionTitle from "./BlueprintImageAccordionTitle";
import BlueprintImageAccordionContent from "./BlueprintImageAccordionContent";
import SuccessFlashMessage from "./SuccessFlashMessage";
import TextOverlayOnImage from "./TextOverlayOnImage";
import PlaceholderImage from "./PlaceholderImage";
import LanguageFlag from "./LanguageFlag";


// gestisco i click fuori dal popup per chiuderlo
function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  // const handleHideDropdown = (event: KeyboardEvent) => {
  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

// gestisco i click fuori dal popup per aprire il popup
  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return {ref, isComponentVisible, setIsComponentVisible};
}


function IndexBlueprintImages(props) {
  const dispatch = useDispatch();
  const blueprintImages = useSelector(state => state.blueprintImages)
  const blueprintImagesCount = useSelector(state => state.blueprintImagesCount)
  const page = useSelector(state => state.page)
  const hasLoadedAllBlueprintImages = useSelector(state => state.hasLoadedAllBlueprintImages)
  const loadingCards = useSelector(state => state.loading)
  const showFullScreenLoadingOverlay = useSelector(state => state.showFullScreenLoadingOverlay)
  const showSuccessFlashMessage = useSelector(state => state.showSuccessFlashMessage)
  const successFlashMessage = useSelector(state => state.successFlashMessage)
  const showErrorModal = useSelector(state => state.showErrorModal)
  const showSuccessModal = useSelector(state => state.showSuccessModal)
  const successMessage = useSelector(state => state.successMessage)
  const blueprintImage2ShowLargeImage = useSelector(state => state.blueprintImage2ShowLargeImage)
  const showZoomImg = useSelector(state => state.showZoomImg)
  const disable_marketplace = props.disable_marketplace
  const [display, setDisplay] = useState("list");
  const [showAlertPopupMyCollection, setShowAlertPopupMyCollection] = useState(false)
  const [showAlertPopupWishlist, setShowAlertPopupWishlist] = useState(false)
  const [blueprintImageToAdd, setBlueprintImageToAdd] = useState(false)
  const [showRequiredLoginModal, setShowRequiredLoginModal] = useState(false);

  // console.log('blueprintImages: ', blueprintImages)
  // console.log('ITIAL PAGE: ', page)


  // add loader refrence
  const loader = useRef(null);

  useEffect(() => {
    const initialBlueprintImages = JSON.parse(props.initial_blueprint_images);
    
    dispatch(setInitialParams(
      null, props.initial_filters.name !== "" ? initialBlueprintImages.blueprint_images_count : null,
      props.available_options_for_select, props.initial_filters,
      props.logged_in_user, null, props.sorting_options, props.sorting_directions,
      {}, [], 'advanced_search', [], [],
      null, null, [], [], [])
    )
    dispatch(getExpansions(props.initial_filters.game_id, props.initial_filters.era_id, props.initial_filters.released_at, props.initial_filters.edition));
    dispatch(getEras(props.initial_filters.game_id, props.initial_filters.released_at, props.initial_filters.edition));
    dispatch(getNewOptionsForFilters(props.initial_filters.era_id, props.initial_filters.expansion_id, props.initial_filters.game_id));
    dispatch(appendBlueprintImages(initialBlueprintImages.blueprint_images, SMALL_PER_PAGE_PARAM))
  }, []);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current)
    }

  }, []);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      dispatch(getBlueprintImages(SMALL_PER_PAGE_PARAM))
    }
  }

  const addCardToWishlistHandler = (blueprintImage) => (_event) => {
    setShowAlertPopupWishlist(false)
    dispatch(addCardToWishlist(blueprintImage))
  }

  const addCardToMyCollectionHandler = (blueprintImage) => (_event) => {
    setShowAlertPopupMyCollection(false)
    dispatch(addCardToMyCollection(blueprintImage))
  }

  const viewOffersHandler = (blueprintImage) => (_event) => {
    dispatch(viewOffers(blueprintImage))
    _event.stopPropagation()
  }

  const setBlueprintImageParamHandler = (blueprintImage, key, value) => {
    if (value === '' || value > 0) {
      dispatch(setBlueprintImageParam(blueprintImage, key, value))
    }
  }

  const handleSetShowSuccessFlashMessage = (value) => {
    dispatch(setShowSuccessFlashMessage(value))
  }

  const handleSetShowErrorModal = (value) => {
    dispatch(setShowErrorModal(value))
  }

  const handleSetShowSuccessModal = (value) => {
    dispatch(setShowSuccessModal(value))
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita di una carta
  const handleShowLargeImage = (e, blueprintImage) => {
    if (blueprintImage && blueprintImage.xx_large_image_url) {
      dispatch(setBlueprintImage2ShowLargeImage(blueprintImage, null))
      dispatch(setShowZoomImg(true))
      e.stopPropagation()
    }
  }


  // Funzione che permette di mostrare / nascondere la modale di rendering in full-screen mode dell'immagine
  // ingrandita di una carta
  const handleShowHideLargeImage = (show) => {
    dispatch(setShowZoomImg(show))
  }

  // Funzione che permette di cambiare la modalità di visualizzazione delle offerte da griglia a lista o viceversa
  const switchTab = (e) => {
    if (e.target.id === "button-list") {
      setDisplay("list");
    } else if (e.target.id === "button-block") {
      setDisplay("block");
    } else {
      setDisplay("table");
    }
  };

  // Link alla pagina del dettaglio della blueprintImage
  const goToBlueprintImageDetail = (e, id) => {
    window.open(`/blueprint_images/${id}`, '_blank')
    e.stopPropagation()
  };

  // Show action modal to add product to my collection, wishlist
  const showActionModal = (e, blueprintImage) => {

    // console.log('X=',e.pageX)
    // console.log('Y=',e.pageY)
    // console.log('x0=',$('#add-btn-of-'+blueprintImage.id).offset().left)
    // console.log('y0=',$('#add-btn-of-'+blueprintImage.id).offset().top)

    setBlueprintImageToAdd(blueprintImage)

    if (window.innerWidth<IPAD_WIDTH){
      $('.bubble-adv-search').css('top', e.pageY + 40 - $(window).scrollTop() + 'px')
      $('.bubble-adv-search').css('left', e.pageX - 105 + 'px')
    }else {
      if (display == 'list') {
        // Se sto visualizzando la pagina con la tabella con l'immagine
        // assegno come valore di Top al popup quello derivante da:
        // La posizione del bordo superiore del bottone cliccatoin pagina meno:
        // il numero di px scrollati sulla pagina, meno metà dell'altezza del popup, più 24px che è metà altezza del bottone stesso
        $('.bubble-adv-search').css('top', $('#add-btn-of-' + blueprintImage.id).offset().top - $(window).scrollTop() - 80 + 'px')

        //Assegno il valore alla posizione left del popup prendendo la posizione x del bordo sinistro del bottone e sottraendo
        // la larghezza complessiva (popup + quadrato per la freccia) in px del popup
        $('.bubble-adv-search').css('left', $('#add-btn-of-' + blueprintImage.id).offset().left - 220 + 'px')
      } else {
        // nelle altre visualizzazioni
        // Se sto visualizzando la pagina con la tabella con l'immagine
        // assegno come valore di Top al popup quello derivante da:
        // La posizione del bordo superiore del bottone cliccatoin pagina a cui sommo:
        // 50px altezza del bottone stesso 20px lunghezza diagonale della feccia sul popup
        // sottraggo l'eventuale scroll fatto dall'utente
        $('.bubble-adv-search').css('top', $('#add-btn-of-' + blueprintImage.id).offset().top + 60 - $(window).scrollTop() + 'px')

        //Assegno il valore alla posizione left del popup prendendo la posizione x del bordo sinistro del bottone e sottraendo
        // la larghezza complessiva (popup + quadrato per la freccia) in px del popup
        $('.bubble-adv-search').css('left', $('#add-btn-of-' + blueprintImage.id).offset().left -87 + 'px')
      }
    }


    setIsComponentVisible(true);
    e.stopPropagation()
  };

  // intercetto l'inizio dello scroll e nascondo il popup
  $(window).scroll(function () {
    setIsComponentVisible(false);
  })

// Oggetto che serve per gestire il popup contentente le azioni che si possono fare
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  // Funzione che apre un pop up che chiede conferma all'utente circa la sua volontà di inserire nella sua
  // my collection / wishlist i prodotti sealed che ha selezionato sull'interfaccia grafica
  const openAlertPopup = (popupType) => {

    if(window.innerWidth<IPAD_WIDTH){
      setIsComponentVisible(false);
    }

    if (props.logged_in_user) {
      switch (popupType) {
        case 'wishList':
          setShowAlertPopupWishlist(true)
          break;
        case 'myCollection':
          setShowAlertPopupMyCollection(true)
          break;
      }
    } else {
      setShowRequiredLoginModal(true)
    }
  }

  // Funzione setta il numero di prodotti da aggiungere alla my collection
  const setProductsNumber = (blueprintImage, value) => {
    setBlueprintImageParamHandler(blueprintImage, 'quantity', value)
  }




  return (
    <React.Fragment>
      <div className="col-12 col-lg-8 fix-header-advanced-search bg-white">
        <div className="row mr-30px force-h-95px">
          <div className="col-12 col-md-6 mt-10px mb-10px pl-lg-0">
            {
              blueprintImagesCount !== null && blueprintImagesCount !== undefined && blueprintImagesCount > 0 &&
              <React.Fragment>
                <h2 className="text-weight-700 mb-0">{blueprintImagesCount}</h2>
                <p className="text-weight-300 mb-0">{I18n.t('js.advancedSearch.resultsFound')}</p>
              </React.Fragment>
            }
          </div>
          <div id="change-view-AS" className="col-12 col-md-6 mt-10px mb-10px pt-20px pr-0">
            <SwitchDisplay switchTab={switchTab}
                           listTabColor={`${display == 'list' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                           blockTabColor={`${display == 'block' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                           tableTabColor={`${display == 'table' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                           blockLayoutOnlyFor={'show-on-desktop-imp'}
            />
          </div>
        </div>
      </div>


      <div className="ml-3 ml-lg-0 mr-3 mr-lg-5 mb-5">

        <div id="advanced-search-results" className="bg-white-on-desktop mt-desktop-95px">

          {display == 'table' &&
          <div className="table-responsive" hidden={blueprintImages.length === 0}>
            <table className="table table-hover bg-white">
              <thead className="thead-dark">
              <tr>
                <th className="text-center"/>
                <th className="text-center">Info</th>
                <th className="text-center"/>
                <th className="text-center"/>
                <th className="text-center"/>
              </tr>
              </thead>
              <tbody>
              {blueprintImages.map(blueprintImage => {
                const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
                const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)

                return <tr key={blueprintImage.id} id={blueprintImage.id}
                           style={{cursor: 'pointer'}}
                           onClick={(e) => window.open(`/blueprint_images/${blueprintImage.id}`, '_blank') }
                        >
                  <td className="text-center p-0" style={{cursor: 'auto'}}
                      onClick={(e) => e.stopPropagation() }>
                    <OverlayTrigger
                      placement={window.innerWidth <= 1050 ? "right" : "left"}
                      overlay={
                        <Tooltip id={`blueprintImage-tooltipInfo`} className="minW-250px">
                          <div className="d-flex justify-content-center position-relative text-center w-100 h-100">
                            {
                              blueprintImage.medium_image_url ?
                                <React.Fragment>
                                  <img
                                    className={`image-card-list-tooltip mt-4 mb-4`}
                                    src={blueprintImage.medium_image_url}
                                    alt=""
                                  />

                                  {
                                    !blueprintImage.encasing_id &&
                                    <TextOverlayOnImage
                                      textOverlay={I18n.t('js.common.notGradableProduct')}
                                      size={'medium'}
                                      type={'red-overlay'}
                                    />
                                  }
                                </React.Fragment>
                                :
                                <PlaceholderImage
                                  size={'medium'}
                                  overlaySize={'thumb'}
                                  additionalClasses="image-card-list-tooltip  rounded mt-4 mb-4"
                                  showNotGradableProductOverlay={!blueprintImage.encasing_id}
                                />
                            }
                          </div>
                        </Tooltip>
                      }
                    >
                      <i className="fas fa-camera fa-lg"></i>
                    </OverlayTrigger>
                  </td>

                  <td className="align-baseline">
                    <p id={"name_" + blueprintImage.id} className="mb-0">
                      {
                        blueprintImageNames.length > 1 ?
                          <b>
                            { blueprintImageNames[0] }
                            <small className="ml-1">
                              <b>
                                ({ blueprintImageNames[1] })
                              </b>
                            </small>
                          </b>
                          :
                          <b>
                            { blueprintImageNames[0] }
                          </b>
                      }
                    </p>

                    {
                      getArtwork(blueprintImage) ? <p><small>[{getArtwork(blueprintImage)}]</small></p> : <React.Fragment></React.Fragment>
                    }

                    {
                      blueprintImage.collector_number && blueprintImage.collector_number !== '' &&
                      <p className="mb-0">
                        <b>{I18n.t('js.advancedSearch.productProperty.collectorNumber')}:&nbsp;</b>
                        <span>{blueprintImage.collector_number}</span>
                      </p>
                    }

                    <p id={"expansion_" + blueprintImage.id} className="mb-0">
                      {
                        blueprintImage.expansion_full_name &&
                        <React.Fragment>
                          <b>{I18n.t('js.advancedSearch.productProperty.expansion')}:&nbsp;</b>
                          <span>
                            { blueprintImage.expansion_full_name }
                          </span>
                        </React.Fragment>
                      }

                      <ExpansionIcon
                        icon_url={blueprintImage.expansion.icon_url}
                        width={'35px'}
                      />
                    </p>

                  </td>
                  <td className=" align-baseline">

                    <p id={"category_" + blueprintImage.id} className="">
                      { parseCategoryName(blueprintImage.blueprint.category.name) }
                    </p>

                    {
                      blueprintImage.version && blueprintImage.version !== '' &&
                      <p id={"version_" + blueprintImage.id} className="">
                        <span> {titleize(blueprintImage.version)}</span>
                      </p>
                    }


                    {
                      blueprintImage.edition && !compareStrings(blueprintImage.edition, 'Undefined') && blueprintImage.edition !== "" &&
                      <p className="mb-0">
                        <span>{titleize(blueprintImage.edition)}</span>
                      </p>
                    }


                  </td>
                  <td className=" align-baseline text-center">
                    <p className="mb-1">
                      <img src={window.location.origin + `/images/flags/${blueprintImage.language}.png`}
                           style={{maxHeight: "20px", marginRight: "15px", marginTop: "5px"}} className="m-auto"
                           alt=""/>
                    </p>

                    {
                      blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
                      <p id={"rarity_" + blueprintImage.id} className="mb-0">

                        {
                          blueprintImage.rarity_logo_url ?
                            <img src={blueprintImage.rarity_logo_url} alt="" className="ml-1"
                                 style={{maxWidth: '20px'}}/>
                            :
                            <span className="text-nowrap"> {titleize(blueprintImage.rarity)} </span>
                        }

                      </p>
                    }

                    {
                      blueprintImage.version && blueprintImage.released_at !== '' &&
                      <p className="mb-0">
                        <span>{blueprintImage.released_at.split('-')[0]}</span>
                      </p>
                    }

                    {
                      blueprintImage.already_in_wishlist > 0 &&
                      <a
                        id={`ad-wishlist-link-${blueprintImage.id}`}
                        href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
                        className="text-center"
                        onClick={(e) => e.stopPropagation()}
                      >

                        <IconTooltip
                          tooltipPosition={'top'}
                          tooltipIcon={'fas fa-heart mt-1 mr-3'}
                          tooltipTitle={I18n.t('js.indexSealedPage.productInwishlistTitle')}
                          tooltipContent={I18n.t('js.advancedSearch.tooltipProductInWishlistContentLink')}
                          iconColor={'#00a2dd'}
                        />
                      </a>
                    }
                  </td>
                  <td className="align-baseline w-180px">

                    <div className="w-100 m-auto text-center">
                      {
                        !disable_marketplace &&
                          <React.Fragment>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                                </Tooltip>
                              }
                            >
                              <div>
                                <input className="mr-2 form-control noselect"
                                       id={`input-quantity-of-${blueprintImage.id}`}
                                       value={blueprintImage.quantity}
                                       name="bluprint_image_quantity"
                                       type="number"
                                       onClick={(e) => e.stopPropagation()}
                                       onKeyDown={(e) => onKeyDownQuantity(e)}
                                       onChange={(e) => setProductsNumber(blueprintImage, e.target.value)}
                                       data-id={blueprintImage.id}
                                />
                              </div>

                            </OverlayTrigger>

                            <p className="text-weight-300 mb-0 text--size-small">{I18n.t('js.advancedSearch.quantity')}</p>

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  <p>{I18n.t('js.advancedSearch.tooltipAddBtn')}</p>
                                </Tooltip>
                              }
                            >
                              <button
                                id={`add-btn-of-${blueprintImage.id}`}
                                className="bg-aig-gradient text-light btn-squre-with-icon mt-10px mr-10px"
                                type="button"
                                onClick={(e) => showActionModal(e, blueprintImage)}
                              >
                                <i className="fa fa-plus-circle fa-lg mr-2px"/>
                              </button>
                            </OverlayTrigger>
                          </React.Fragment>
                      }

                      {
                        !disable_marketplace && blueprintImage.has_offers &&
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-top`}>
                                <p>{I18n.t('js.advancedSearch.tooltipViewBtn')}</p>
                              </Tooltip>
                            }
                          >
                            <button
                              id={`view-offer-btn-of-${blueprintImage.id}`}
                              className=" bg-dark text-light btn-squre-with-icon  mt-10px mr-10px ml-10px-imp"
                              type="button"
                              onClick={viewOffersHandler(blueprintImage)}
                            >
                              <i className="fa fa-eye fa-lg mr-2px"/>
                            </button>
                          </OverlayTrigger>
                      }

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            <p>{I18n.t('js.advancedSearch.tooltipinfoBtn')}</p>
                          </Tooltip>
                        }
                      >
                        <button
                          id={`info-btn-of-${blueprintImage.id}`}
                          className="btn-squre-with-icon bg-dark text-light mt-10px ml-10px-imp"
                          type="button"
                          onClick={(e) =>
                            goToBlueprintImageDetail(e, blueprintImage.id)
                          }
                        >
                          <i className="fas fa-info-circle fa-lg"/>
                        </button>
                      </OverlayTrigger>
                    </div>

                  </td>
                </tr>
              })}
              </tbody>
            </table>
          </div>
          }

          {display == 'list' &&
          <React.Fragment>
            <div className={`table-responsive d-none ${blueprintImages.length >0 && 'd-md-block'}`} hidden={blueprintImages.length === 0}>
              <table className="table table-hover bg-white">
                <thead className="thead-dark">
                <tr>
                  <th className="text-center">{I18n.t('js.advancedSearch.tableView.tableHeaderProduct')}</th>
                  <th className="text-center"/>
                  <th className="text-center"/>
                  <th className="text-center"/>
                </tr>
                </thead>
                <tbody>
                {blueprintImages.map((blueprintImage , i) => {
                  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
                  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)

                  return <tr key={blueprintImage.id +'_'+ i}
                             id={blueprintImage.id}
                             style={{cursor: 'pointer'}}
                             onClick={(e) => window.open(`/blueprint_images/${blueprintImage.id}`, '_blank') }
                  >
                    <td className="text-left">
                      <div className="position-relative">
                        <ShowBlueprintImageFrontImage
                          size={'medium'}
                          blueprintImage={blueprintImage}
                          handleShowLargeImage={handleShowLargeImage}
                          cursor={blueprintImage.medium_image_url ? 'zoom-in' : 'auto'}
                          textOverlayPlaceholder={getArtwork(blueprintImage)}
                        />
                        {
                          blueprintImage.already_in_wishlist > 0 &&
                          <div className="position-absolute icon-heart-position-list">
                            <a
                              href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
                              className="text-center"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <IconTooltip
                                tooltipPosition={'top'}
                                tooltipIcon={'fas fa-heart'}
                                tooltipTitle={I18n.t('js.indexSealedPage.productInwishlistTitle')}
                                tooltipContent={I18n.t('js.advancedSearch.tooltipProductInWishlistContent')}
                                iconColor={'#00a2dd'}
                              />
                            </a>
                          </div>

                        }
                      </div>

                    </td>
                    <td className="align-baseline">
                      <p id={"name_" + blueprintImage.id} className="mb-0">
                        {
                          blueprintImageNames.length > 1 ?
                            <b>
                              { blueprintImageNames[0] }
                              <small className="ml-1">
                                <b>
                                  ({ blueprintImageNames[1] })
                                </b>
                              </small>
                            </b>
                            :
                            <b>
                              { blueprintImageNames[0] }
                            </b>
                        }
                      </p>

                      {
                        getArtwork(blueprintImage) &&
                          <p className="mb-0">
                            <b>{I18n.t('js.advancedSearch.productProperty.artwork')}:&nbsp;</b>
                            <span>{getArtwork(blueprintImage)}</span>
                          </p>
                      }

                      {
                        blueprintImage.collector_number && blueprintImage.collector_number !== '' &&
                          <p className="mb-0">
                            <b>{I18n.t('js.advancedSearch.productProperty.collectorNumber')}:&nbsp;</b>
                            <span>{blueprintImage.collector_number}</span>
                          </p>
                      }

                      <div className="mb-0">
                        <b>{I18n.t('js.advancedSearch.productProperty.brand')}:&nbsp;</b>
                        <GameNameParser game_name={blueprintImage.game.name} />
                      </div>

                      {
                        (blueprintImage.en_era_name || blueprintImage.era_name) &&
                          <p id={"era_" + blueprintImage.id} className="mb-0">
                          <b>{I18n.t('js.advancedSearch.productProperty.era')}:&nbsp;</b>
                          {
                            eraNames.length > 1 ?
                              <span>
                                { eraNames[0] }
                                  <small className="ml-1">
                                  ({ eraNames[1] })
                                </small>
                              </span>
                            :
                              <span>
                                { eraNames[0] }
                              </span>
                          }
                        </p>
                      }

                      <p id={"expansion_" + blueprintImage.id} className="mb-0">
                        {
                          blueprintImage.expansion_full_name &&
                            <React.Fragment>
                              <b>{I18n.t('js.advancedSearch.productProperty.expansion')}:&nbsp;</b>
                              <span>
                                { blueprintImage.expansion_full_name }
                              </span>
                            </React.Fragment>
                        }

                        <ExpansionIcon
                          icon_url={blueprintImage.expansion.icon_url}
                          width={'35px'}
                        />
                      </p>
                      <p id={"category_" + blueprintImage.id} className="mb-0">
                        <b>
                          {I18n.t('js.advancedSearch.productProperty.category')}:
                          &nbsp;
                        </b>
                        { parseCategoryName(blueprintImage.blueprint.category.name) }
                      </p>
                    </td>

                    <td className="w-250 align-baseline">
                      <div className="d-flex align-items-center mb-0">
                        <b>{I18n.t('js.advancedSearch.productProperty.language')}:&nbsp;</b>
                        <span className="mr-2">
                          { parseLanguage(blueprintImage.language_filter) }
                        </span>
                        <LanguageFlag
                          language={blueprintImage.language}
                          maxHeight={'15px'}
                        />
                      </div>

                      {
                        blueprintImage.version && blueprintImage.version !== '' &&
                        <p id={"version_" + blueprintImage.id} className="mb-0">
                          <span><b>{I18n.t('js.advancedSearch.productProperty.version')}:&nbsp;</b> {titleize(blueprintImage.version)}</span>
                        </p>
                      }

                      {
                        blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
                        <p id={"rarity_" + blueprintImage.id} className="mb-0">
                          <span>
                            <b>{I18n.t('js.advancedSearch.productProperty.rarity')}:&nbsp;</b> {titleize(blueprintImage.rarity)}
                            {
                              blueprintImage.rarity_logo_url &&
                              <img src={blueprintImage.rarity_logo_url} alt="" className="ml-1"
                                   style={{maxWidth: '20px'}}/>
                            }
                            </span>
                        </p>
                      }


                      {
                        blueprintImage.edition && !compareStrings(blueprintImage.edition, 'Undefined') && blueprintImage.edition !== "" &&
                        <p className="mb-0">
                          <span><b>{I18n.t('js.advancedSearch.productProperty.edition')}:&nbsp;</b> {titleize(blueprintImage.edition)}</span>
                        </p>
                      }


                      {
                        blueprintImage.version && blueprintImage.released_at !== '' &&
                        <p className="mb-0">
                          <span><b>{I18n.t('js.advancedSearch.productProperty.releaseAt')}:&nbsp;</b> {titleize(blueprintImage.released_at)}</span>
                        </p>
                      }


                      {
                        blueprintImage.print_sheet_code &&
                        <p className="mb-0">
                          <span><b>{I18n.t('js.advancedSearch.productProperty.sheetCode')}:&nbsp;</b>{blueprintImage.print_sheet_code}</span>
                        </p>
                      }

                      {
                        blueprintImage.already_in_wishlist > 0 &&
                        <p className="mt-20px text-weight-500 text--size-09rem">

                          {I18n.t('js.advancedSearch.thisProductInside')} <a
                          href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
                          className="data-structure-link"
                          style={{
                            color: "inherit",
                            textDecoration: "underline"
                          }}
                          onClick={(e) => e.stopPropagation()}>
                          {I18n.t('js.advancedSearch.yourWishlist')}
                        </a>
                        </p>
                      }

                    </td>
                    <td className="align-baseline">

                      <div className="w-60px m-auto text-center">
                        {
                          !disable_marketplace &&
                            <React.Fragment>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                                  </Tooltip>
                                }
                              >
                                <div>
                                  <input className="mr-2 form-control noselect"
                                         id={`input-quantity-of-${blueprintImage.id}`}
                                         value={blueprintImage.quantity}
                                         name="bluprint_image_quantity"
                                         type="number"
                                         style={{width: "60px"}}
                                         onClick={(e) => e.stopPropagation()}
                                         onKeyDown={(e) => onKeyDownQuantity(e)}
                                         onChange={(e) => setProductsNumber(blueprintImage, e.target.value)}
                                         data-id={blueprintImage.id}
                                  />
                                </div>
                              </OverlayTrigger>
                              <p className="text-weight-300 mb-0 text--size-small">{I18n.t('js.advancedSearch.quantity')}</p>


                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    <p>{I18n.t('js.advancedSearch.tooltipAddBtn')}</p>
                                  </Tooltip>
                                }
                              >
                                <button
                                  id={`add-btn-of-${blueprintImage.id}`}
                                  className="bg-aig-gradient text-light btn-squre-with-icon mt-10px mb-10px"
                                  type="button"
                                  onClick={(e) => showActionModal(e, blueprintImage)}
                                >
                                  <i className="fa fa-plus-circle fa-lg"/>
                                </button>
                              </OverlayTrigger>
                            </React.Fragment>
                        }

                        {
                          !disable_marketplace && blueprintImage.has_offers &&
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  <p>{I18n.t('js.advancedSearch.tooltipViewBtn')}</p>
                                </Tooltip>
                              }
                            >
                              <button
                                id={`view-offer-btn-of-${blueprintImage.id}`}
                                className=" bg-dark text-light btn-squre-with-icon  mt-10px mb-10px"
                                type="button"
                                onClick={viewOffersHandler(blueprintImage)}
                              >
                                <i className="fa fa-eye fa-lg"/>
                              </button>
                            </OverlayTrigger>
                        }

                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              <p>{I18n.t('js.advancedSearch.tooltipinfoBtn')}</p>
                            </Tooltip>
                          }
                        >
                          <button
                            id={`info-btn-of-${blueprintImage.id}`}
                            className="btn-squre-with-icon bg-dark text-light mt-10px mb-20px"
                            type="button"
                            onClick={(e) =>
                              goToBlueprintImageDetail(e, blueprintImage.id)
                            }
                          >
                            <i className="fas fa-info-circle fa-lg"/>
                          </button>
                        </OverlayTrigger>
                      </div>
                    </td>
                  </tr>
                })}
                </tbody>
              </table>
            </div>
            <div className="d-md-none">
              {blueprintImages.map((blueprintImage, i) => {
                return (<Accordion defaultActiveKey={blueprintImages[0].id} className="w-100 mb-3 border-aiG-black-imp br-8px"
                           key={"mobile_" + i + "_" + blueprintImage.id}>
                  <Card className="bg-white border-none border-round-standard">
                    <Accordion.Toggle as={Card.Header} eventKey={blueprintImage.id}>
                      <div className="row">
                        <BlueprintImageAccordionTitle
                          blueprintImage={blueprintImage}
                          handleShowLargeImage={handleShowLargeImage}
                        />
                      </div>
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey={blueprintImage.id}>
                      <div className="row mt-10px pb-3">
                        <div className="col-12">
                          <BlueprintImageAccordionContent
                            blueprintImage={blueprintImage}
                          />

                          {
                            !disable_marketplace &&
                            <div className="row w-100 ml-negative-8px mt-10px-imp">
                              <div className="col-xs-4 col-md-2 mt-10px-imp">
                                <p
                                  className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.advancedSearch.quantity")}:</p>
                              </div>

                              <div className="col-xs-8 col-md-4">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-top`}>
                                      <p>{I18n.t("js.common.quantityTooltipContent")}</p>
                                    </Tooltip>
                                  }
                                >
                                  <div className="float-right">
                                    <input className="mr-2 form-control noselect"
                                           id={`input-quantity-of-${blueprintImage.id}`}
                                           value={blueprintImage.quantity}
                                           name="bluprint_image_quantity"
                                           type="number"
                                           onClick={(e) => e.stopPropagation()}
                                           onKeyDown={(e) => onKeyDownQuantity(e)}
                                           onChange={(e) => setProductsNumber(blueprintImage, e.target.value)}
                                           data-id={blueprintImage.id}
                                    />
                                  </div>
                                </OverlayTrigger>
                              </div>
                            </div>
                          }

                          <div className="row w-100 ml-negative-8px mt-10px-imp">
                            <div className="col-xs-5 pt-1">
                              {
                                !disable_marketplace && blueprintImage.has_offers &&
                                <a
                                  type="button"
                                  className="btn-standard bg-dark text-light text-center pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto text--size-09rem-imp pb-5px-imp ml-3 w-100px-imp"
                                  href={`/products/${blueprintImage.id}`}
                                >
                                  {I18n.t("js.myWishlistEditPage.viewOffers")}
                                </a>
                              }
                            </div>

                            <div className="col-xs-2">
                              {
                                !disable_marketplace &&
                                  <button
                                    id={`add-btn-of-${blueprintImage.id}`}
                                    className="bg-aig-gradient text-light btn-squre-with-icon mt-10px mb-10px mr-4px m-auto "
                                    type="button"
                                    onClick={(e) => showActionModal(e, blueprintImage)}
                                  >
                                    <i className="fa fa-plus-circle fa-lg" />
                                  </button>
                              }
                            </div>

                            <div className="col-xs-5 pt-1">
                              <a
                                type="button"
                                className="btn-standard bg-dark text-light text-center pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto text--size-09rem-imp pb-5px-imp ml-3 w-100px-imp"
                                target="_blank"
                                href={`/blueprint_images/${blueprintImage.id}`}
                              >
                                {I18n.t("js.advancedSearch.moreInfo")}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>)
              })}
            </div>
          </React.Fragment>

          }
          {display == 'block' &&

          <div hidden={blueprintImages.length === 0} className="row w-100 ml-0 bg-white">
            {blueprintImages.map(blueprintImage => {
              const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
              const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)

              return (<div
                className={`${window.innerWidth > 1537 ? "col-lg-2" : "col-lg-3"}  transform-scale-09 p-0 text-lg-center`}
                key={blueprintImage.id}>
                <div id={"name_" + blueprintImage.id} className="text--truncate">
                  {
                    blueprintImageNames.length > 1 ?
                      <React.Fragment>
                        <p className="ml-1">
                          { blueprintImageNames[0] }
                        </p>
                        <p
                          className="text--size-small">
                          ({ blueprintImageNames[1] })
                        </p>
                      </React.Fragment>
                      :
                      <b>
                        { blueprintImageNames[0] }
                      </b>
                  }
                  <p>
                    {blueprintImage.collector_number}
                  </p>
                </div>

                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Tooltip id="blueprintImage-tooltipInfo">
                      <div className="bg-white text-dark" style={{ fontSize: "18px" }}>

                        <div id={"name_" + blueprintImage.id} className="mb-0">
                          {
                            blueprintImageNames.length > 1 ?
                              <React.Fragment>
                                <p className="ml-1">
                                  { blueprintImageNames[0] }
                                </p>
                                <p
                                  className="text--size-small">
                                  ({ blueprintImageNames[1] })
                                </p>
                              </React.Fragment>
                              :
                              <b>
                                { blueprintImageNames[0] }
                              </b>
                          }
                        </div>

                        {
                          getArtwork(blueprintImage) &&
                          <p className="mb-0">
                            <b>{I18n.t("js.advancedSearch.productProperty.artwork")}:&nbsp;</b>
                            <span>{getArtwork(blueprintImage)}</span>
                          </p>
                        }

                        {
                          blueprintImage.collector_number &&
                          <p className="mb-0">
                            <b>{I18n.t("js.advancedSearch.productProperty.collectorNumber")}:&nbsp;</b>
                            <span>{blueprintImage.collector_number}</span>
                          </p>
                        }

                        <div className="mb-0 pb-0 ml-0 pl-0 d-flex justify-content-start">
                          <b>{I18n.t("js.advancedSearch.productProperty.brand")}:&nbsp;</b>
                          <GameNameParser game_name={blueprintImage.game.name} />
                        </div>


                        {
                          (blueprintImage.en_era_name || blueprintImage.era_name) &&
                          <p id={"era_" + blueprintImage.id} className="mb-0">
                            <b>{I18n.t("js.advancedSearch.productProperty.era")}:&nbsp;</b>
                            {
                              eraNames.length > 1 ?
                                <span>
                                  { eraNames[0] }
                                  <small className="ml-1">
                                    ({ eraNames[1] })
                                  </small>
                                </span>
                              :
                                <span>
                                  { eraNames[0] }
                                </span>
                            }
                          </p>
                        }

                        <p id={"expansion_" + blueprintImage.id} className="mb-0">
                          {
                            blueprintImage.expansion_full_name &&
                            <React.Fragment>
                              <b>{I18n.t("js.advancedSearch.productProperty.expansion")}:&nbsp;</b>
                              <span>
                                { blueprintImage.expansion_full_name }
                              </span>
                            </React.Fragment>
                          }

                          <ExpansionIcon
                            icon_url={blueprintImage.expansion.icon_url}
                            width={"35px"}
                          />
                        </p>
                        <p id={"category_" + blueprintImage.id} className="mb-0">
                          <b>
                            {I18n.t("js.advancedSearch.productProperty.category")}:
                            &nbsp;
                          </b>
                          {parseCategoryName(blueprintImage.blueprint.category.name)}
                        </p>

                        <div className="d-flex align-items-center mb-0">
                          <b>{I18n.t("js.advancedSearch.productProperty.language")}:&nbsp;</b>
                          <span className="mr-2">
                            { parseLanguage(blueprintImage.language_filter) }
                          </span>
                          <LanguageFlag
                            language={blueprintImage.language}
                            maxHeight={'15px'}
                          />
                        </div>

                        {
                          blueprintImage.version && blueprintImage.version !== "" &&
                          <p id={"version_" + blueprintImage.id} className="mb-0">
                            <span><b>{I18n.t("js.advancedSearch.productProperty.version")}:&nbsp;</b> {titleize(blueprintImage.version)}</span>
                          </p>
                        }

                        {
                          blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
                          <p id={"rarity_" + blueprintImage.id} className="mb-0">
                          <span>
                            <b>{I18n.t("js.advancedSearch.productProperty.rarity")}:&nbsp;</b> {titleize(blueprintImage.rarity)}
                            {
                              blueprintImage.rarity_logo_url &&
                              <img src={blueprintImage.rarity_logo_url} alt="" className="ml-1"
                                   style={{ maxWidth: "20px" }} />
                            }
                            </span>
                          </p>
                        }


                        {
                          blueprintImage.edition && blueprintImage.edition !== "Undefined" && blueprintImage.edition !== "" &&
                          <p className="mb-0">
                            <span><b>{I18n.t("js.advancedSearch.productProperty.edition")}:&nbsp;</b> {titleize(blueprintImage.edition)}</span>
                          </p>
                        }


                        {
                          blueprintImage.version && blueprintImage.released_at !== "" &&
                          <p className="mb-0">
                            <span><b>{I18n.t("js.advancedSearch.productProperty.releaseAt")}:&nbsp;</b> {titleize(blueprintImage.released_at)}</span>
                          </p>
                        }


                        {
                          blueprintImage.print_sheet_code &&
                          <p className="mb-0">
                            <span><b>{I18n.t("js.advancedSearch.productProperty.sheetCode")}:&nbsp;</b>{blueprintImage.print_sheet_code}</span>
                          </p>
                        }

                        {
                          blueprintImage.already_in_wishlist > 0 &&
                          <p className="mt-20px text-weight-500 text--size-09rem">

                            {I18n.t("js.advancedSearch.thisProductInside")} <a
                            href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
                            className="data-structure-link"
                            style={{
                              color: "inherit",
                              textDecoration: "underline"
                            }}
                            onClick={(e) => e.stopPropagation()}>
                            {I18n.t("js.advancedSearch.yourWishlist")}
                          </a>
                          </p>
                        }
                      </div>
                    </Tooltip>
                  }
                >
                  <div id={`img-blueprintImage-${blueprintImage.id}`}>
                    <ShowBlueprintImageFrontImage
                      size={"medium"}
                      blueprintImage={blueprintImage}
                      handleShowLargeImage={handleShowLargeImage}
                      cursor={blueprintImage.medium_image_url ? "zoom-in" : "auto"}
                      textOverlayPlaceholder={getArtwork(blueprintImage)}
                    />

                    {
                      blueprintImage.expansion.icon_url &&
                        <div
                          className="font-card-number m-auto position-absolute container-blueprint-image-expansion-icon"
                          style={{maxWidth: "35px", minWidth: "30px"}}
                        >
                          <img src={blueprintImage.expansion.icon_url}
                               style={{ maxHeight: "35px",}} alt=""/>
                        </div>
                    }

                    {
                      blueprintImage.already_in_wishlist > 0 &&
                      <div
                        className="m-auto position-absolute container-heart-icon"
                        style={{maxWidth: "35px", minWidth: "30px"}}
                      >
                        <a
                          href={`/wishlists/${blueprintImage.already_in_wishlist}/edit`}
                          className="text-center"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <IconTooltip
                            tooltipPosition={"top"}
                            tooltipIcon={"fas fa-heart"}
                            tooltipTitle={I18n.t("js.indexSealedPage.productInwishlistTitle")}
                            tooltipContent={I18n.t("js.advancedSearch.tooltipProductInWishlistContent")}
                            iconColor={"#00a2dd"}
                          />
                        </a>
                      </div>
                    }
                  </div>
                </OverlayTrigger>

                <div className="mt-10px-imp w-100 m-auto text-center">
                  {
                    !disable_marketplace &&
                    <React.Fragment>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            <p>{I18n.t("js.common.quantityTooltipContent")}</p>
                          </Tooltip>
                        }
                      >
                        <div className="max-w-150px m-auto">
                          <input className="mr-2 form-control noselect"
                                 id={`input-quantity-of-${blueprintImage.id}`}
                                 value={blueprintImage.quantity}
                                 name="bluprint_image_quantity"
                                 type="number"
                                 onClick={(e) => e.stopPropagation()}
                                 onKeyDown={(e) => onKeyDownQuantity(e)}
                                 onChange={(e) => setProductsNumber(blueprintImage, e.target.value)}
                                 data-id={blueprintImage.id}
                          />
                        </div>
                      </OverlayTrigger>

                      <p className="text-weight-300 mb-0 text--size-small">{I18n.t("js.advancedSearch.quantity")}</p>

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            <p>{I18n.t("js.advancedSearch.tooltipAddBtn")}</p>
                          </Tooltip>
                        }
                      >
                        <button
                          id={`add-btn-of-${blueprintImage.id}`}
                          className="bg-aig-gradient text-light btn-squre-with-icon mt-10px mb-10px mr-4px"
                          type="button"
                          onClick={(e) => showActionModal(e, blueprintImage)}
                        >
                          <i className="fa fa-plus-circle fa-lg mr-2px" />
                        </button>
                      </OverlayTrigger>
                    </React.Fragment>
                  }

                  {
                    !disable_marketplace && blueprintImage.has_offers &&
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>
                          <p>{I18n.t("js.advancedSearch.tooltipViewBtn")}</p>
                        </Tooltip>
                      }
                    >
                      <button
                        id={`view-offer-btn-of-${blueprintImage.id}`}
                        className=" bg-dark text-light btn-squre-with-icon  mt-10px mb-10px mr-4px ml-4px"
                        type="button"
                        onClick={viewOffersHandler(blueprintImage)}
                      >
                        <i className="fa fa-eye fa-lg mr-2px" />
                      </button>
                    </OverlayTrigger>
                  }

                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        <p>{I18n.t("js.advancedSearch.tooltipinfoBtn")}</p>
                      </Tooltip>
                    }
                  >
                    <button
                      id={`info-btn-of-${blueprintImage.id}`}
                      className="btn-squre-with-icon bg-dark text-light mt-10px mb-20px ml-4px"
                      type="button"
                      onClick={(e) =>
                        goToBlueprintImageDetail(e, blueprintImage.id)
                      }
                    >
                      <i className="fas fa-info-circle fa-lg" />
                    </button>
                  </OverlayTrigger>
                </div>
              </div>)
            })}
          </div>


          }
          {/*questo va scommentato e da capire perchè chiama sempre il server se non visualizzo i dati con la tabella */}
          <div ref={loader} hidden={hasLoadedAllBlueprintImages || blueprintImages.length === 0 || loadingCards}/>
          {
            loadingCards ?
              <div className="d-flex justify-content-center mt-5">
                <div className="d-flex align-items-center text-muted">
                  <div className="spinner-border mt-10px mb-10px" role="status"/>
                  <b className="ml-2">{I18n.t('js.advancedSearch.loading')}</b>
                </div>
              </div>
              :
              blueprintImages.length === 0 &&
              <div className="d-flex justify-content-center mt-5">
                <div className="d-flex align-items-center text-muted">
                  <b className="ml-2 mb-10px mt-10px">{I18n.t('js.advancedSearch.noData')}</b>
                </div>
              </div>
          }
        </div>

        <FullScreenLoadingOverlay
          showFullScreenLoadingOverlay={showFullScreenLoadingOverlay}
          textFullScreenLoadingOverlay={I18n.t('js.advancedSearch.addCard')}
        />

        <SuccessFlashMessage
          showSuccessFlashMessage={showSuccessFlashMessage}
          setShowSuccessFlashMessage={handleSetShowSuccessFlashMessage}
          successMessage={successFlashMessage}
        />

        <ErrorModal
          showErrorModal={showErrorModal}
          setShowErrorModal={handleSetShowErrorModal}
        />

        <SuccessModal
          showSuccessModal={showSuccessModal}
          setShowSuccessModal={handleSetShowSuccessModal}
          successMessage={successMessage}
        />

        <ShowLargeImageModal
          blueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
          showZoomImg={showZoomImg}
          setShowZoomImg={handleShowHideLargeImage}
        />
      </div>

      <RequiredLoginAlertPopup
        showRequiredLoginAlertPopup={showRequiredLoginModal}
        onClose={setShowRequiredLoginModal}
      />


      {/*Popup a fumetto per aggiungere prodotti alle strutture dati*/}
      <div ref={ref} className={`size-h-3px-w-3px  ${!isComponentVisible && 'd-none'}`}>
        <div className={`bubble-adv-search position-fixed shadow p-2`}>
          <p className="text-weight-700 text-night-blue text-center text-space">
            {I18n.t('js.indexSealedPage.addProductTo')}
          </p>
          {
            !disable_marketplace &&
              <React.Fragment>
                <div className={`border-bottom-dark d-flex justify-content-center pt-20px pb-10px pl-3 pr-3 cursor-pointer ${blueprintImageToAdd.already_in_wishlist > 0 && 'text--disabled'}`}
                     id="add_to_wishlist"
                     onClick={() => !blueprintImageToAdd.already_in_wishlist > 0 && openAlertPopup("wishList")}>
                  <i className="fas fa-heart mr-3 w-5 col-2 p-0 mt-4px"></i>
                  <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInWishlistShort')}</p>
                </div>
                <div className="d-flex justify-content-center pt-10px pb-10px pl-3 pr-3 cursor-pointer"
                     id="add_to_my_collection"
                     onClick={() => openAlertPopup("myCollection")}>
                  <i className="fas fa-gem mr-3 w-5 col-2 p-0 mt-4px"/>
                  <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInMyCollectionShort')}</p>
                </div>
                <div className={`${display == 'list' && window.innerWidth>=IPAD_WIDTH ? 'pointer-right' : 'pointer-top'} pointer-adv-search`}></div>
              </React.Fragment>
          }
        </div>
      </div>

      {/*Alert per add in My collection*/}
      <AlertPopup
        showAlertPopup={showAlertPopupMyCollection}
        onSuccess={addCardToMyCollectionHandler(blueprintImageToAdd)}
        onDiscard={setShowAlertPopupMyCollection}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyCollectionTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMycollectionContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      {/*Alert per add in My wishlist*/}
      <AlertPopup
        showAlertPopup={showAlertPopupWishlist}
        onSuccess={addCardToWishlistHandler(blueprintImageToAdd)}
        onDiscard={setShowAlertPopupWishlist}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

    </React.Fragment>

  );
}


const initialState = {
  blueprintImages: [],
  page: 1,
  hasLoadedAllBlueprintImages: false,
  currentIndex: 0,
  filters: {},
  availableOptionsForSelect: {}
}


const store = createStore(
  reducer,
  initialState,
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk)
);

const AdvancedBlueprintImagesSearchWithProvider = (props) => {
  return (
    <Provider store={store}>
      <div className="row m-auto">
        <div className="col-12 col-lg-4  p-0">
          <FilterBlueprintImages
            perPage={SMALL_PER_PAGE_PARAM}
          />
        </div>
        <div className="col-12 col-lg-8 p-0">
          <IndexBlueprintImages {...props}/>
        </div>
      </div>
    </Provider>
  )
}

export default AdvancedBlueprintImagesSearchWithProvider



